import { render, staticRenderFns } from "./Subtypes.vue?vue&type=template&id=349b7d76&scoped=true&"
import script from "./Subtypes.vue?vue&type=script&lang=js&"
export * from "./Subtypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b7d76",
  null
  
)

export default component.exports